import React from 'react';
import {useTranslation} from 'react-i18next';
import {loadStripe} from '@stripe/stripe-js/pure';
import {usePaymentSettings} from '../hooks';
import {Elements} from '@stripe/react-stripe-js';
import {getEnvVariable} from '../utils/common';

function StripeProvider(props: any) {
  const {i18n} = useTranslation();
  const {paymentSettings, isStripePaymentProvider} = usePaymentSettings();

  const stripeAccount = paymentSettings?.external_account_id;
  const stripePromise = React.useMemo(() => {
    const needLoadStripe = isStripePaymentProvider && stripeAccount;
    const stripeKey = getEnvVariable('REACT_APP_STRIPE_API_KEY');

    if (!needLoadStripe) {
      return null;
    }

    return loadStripe(stripeKey, {stripeAccount});
  }, [isStripePaymentProvider, stripeAccount]);

  return (
    <>
      <Elements
        {...props}
        stripe={stripePromise}
        key={stripeAccount}
        options={{locale: i18n.language}}
      />
    </>
  );
}

export {StripeProvider};
